import { render, staticRenderFns } from "./BuyBase.vue?vue&type=template&id=3d3d1f87&scoped=true&"
import script from "./BuyBase.vue?vue&type=script&lang=js&"
export * from "./BuyBase.vue?vue&type=script&lang=js&"
import style0 from "./BuyBase.vue?vue&type=style&index=0&id=3d3d1f87&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d3d1f87",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/hanzhu/nutstore-webpages/js_src_vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3d3d1f87')) {
      api.createRecord('3d3d1f87', component.options)
    } else {
      api.reload('3d3d1f87', component.options)
    }
    module.hot.accept("./BuyBase.vue?vue&type=template&id=3d3d1f87&scoped=true&", function () {
      api.rerender('3d3d1f87', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/page_price_versions/components/Buy/BuyBase.vue"
export default component.exports